<app-heading [breadcrumbTitleOptions]="breadcrumbTitleOptions" [title]="'Skills & Experience' | sentenceCase" [button]="false" [isbreadcrumb]="from() === 'onboarding' && isPWCEnabled ? false : true"
    [showToggle]="false"></app-heading>

<div class="flex flex-column">
    <div class="flex flex-column gap-1 text-center h6 mb-3">
      <span>Share your expertise and skills to find more placements</span>
    </div>
    <div class="flex flex-column gap-1 text-center mb-3">
      <span>{{ isPWCEnabled ? appName : userFirmName }} is looking for specific skills{{ isPWCEnabled ? '.' : ',' }} Select all that apply to you.</span>
    </div>
</div>

<!-- No Data Skills and Experience -->
<div class="flex flex-column justify-content-center align-items-center h-page-full" *ngIf="false">
    <div class="flex flex-column gap-1 h5 text-center">
        <span>You don't have any education experience entered.</span>
        <span>{{'Please Add experience' | sentenceCase}}</span>
    </div>
</div>
<!-- No Data Skills and Experience  End-->

<!-- Create Skills and Experience -->
<div class="flex flex-column justify-content-between h-page-full">
    <div class="grid xl:w-9 w-full pt-4">
        @for (scl of skillsCriteriaListing; track scl;let i = $index) {
            <div class="col-12 pb-5">
                <p class="mt-0 mb-2 text-lg font-normal">{{scl.name}} <span class="text-sm">{{scl.description}}</span></p>
                @if(scl.label && scl.label.values){
                    <p-floatLabel>
                        <p-multiSelect (onPanelShow)="onMultiSelectPanelShow()" [(ngModel)]="scl.criteriaSelectedOption" [options]="scl.label.values" optionLabel="val" inputId="reviewExperience" [resetFilterOnHide]="true" placeholder="Select all that apply" [resetFilterOnHide]="true" [showToggleAll]="false" scrollHeight="500px" [filter]="true" filterPlaceHolder="Type to search" [autofocusFilter]="true"/>
                        <label for="reviewExperience">Select all that apply</label>
                    </p-floatLabel>
                }
                @if(scl.criteriaSelectedOption.length > 0){
                <div class="flex gap-2 flex-wrap pt-2 xl:flex-row"
                     [class.flex-column]="hasExperienceEnabled(scl.criteriaSelectedOption)">
                    @for (options of scl.criteriaSelectedOption; track options) {
                        <div class="flex gap-2 align-items-center justify-content-start flex-wrap">
                            <p-chip [label]="options.val" (onRemove)="onRemoveChip(options,i)" [removable]="true" />
                            @if(options.isExperienceEnabled){
                                <p-dropdown [options]="scl.experienceLevels" optionLabel="experience" [(ngModel)]="options.selectedExperienceLevel"
                                (onChange)="onExperienceLevelChange(scl, options)"
                                [class.ng-invalid]="hasExperienceLevelError(scl, options)" [class.ng-dirty]="hasExperienceLevelError(scl, options)"
                                placeholder="Select experience level"/>
                                @if(hasExperienceLevelError(scl, options)){
                                    <div class="p-error">This field is required</div>
                                }
                            }
                        </div>
                    }
                </div>
                }
            </div>
        }
    </div>
    <div class="flex gap-3 mt-3">
        <p-button label="back" rounded="true" outlined="true" size="large"
            styleClass="white-space-nowrap" (onClick)="onBack()"></p-button>
        <p-button (onClick)="save()"  [label]="this.from() === 'onboarding' && this.isPWCEnabled ? 'next' : 'save'" rounded="true" size="large" styleClass="white-space-nowrap freshgreen-background"></p-button>
    </div>
</div>
<!-- Create Skills and Experience End-->